"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPinComponentTipTapFields = exports.processPinTipTapFields = void 0;
const assertions_1 = require("./assertions");
function isQuizPin(pin) {
    return pin.type === 'MULTIPLE_CHOICE';
}
function isTeacherPin(pin) {
    return 'teacherSettings' in pin;
}
function processPinTipTapFields(pin, fn) {
    if (isTeacherPin(pin)) {
        const notes = fn({
            tipTapContent: pin.teacherSettings.notes,
            componentId: 'notes',
            field: 'notes',
            fragmentKey: 'notes',
        });
        if (notes) {
            pin.teacherSettings.notes = notes;
        }
        else {
            delete pin.teacherSettings.notes;
        }
    }
    if (isQuizPin(pin)) {
        pin.settings.answers.forEach((answer) => {
            if ((0, assertions_1.isQuizPinAnswerText)(answer)) {
                const answerText = fn({
                    tipTapContent: answer.text,
                    componentId: `quizAnswer`,
                    field: `pin.settings.answers.${answer.id}`,
                    fragmentKey: `${answer.id}`,
                });
                if (answerText) {
                    answer.text = answerText;
                }
                else {
                    delete answer.text;
                }
            }
        });
    }
    pin.pinComponents.forEach((pinComponent) => processPinComponentTipTapFields(pinComponent, fn));
}
exports.processPinTipTapFields = processPinTipTapFields;
function processPinComponentTipTapFields(pinComponent, fn) {
    if ((0, assertions_1.isTextPinComponent)(pinComponent)) {
        const tipTapContent = fn({
            tipTapContent: pinComponent.settings.tipTapContent,
            componentId: pinComponent.id,
            field: 'component.settings.tipTapContent',
            fragmentKey: undefined,
        });
        if (tipTapContent) {
            pinComponent.settings.tipTapContent = tipTapContent;
        }
        else {
            delete pinComponent.settings.tipTapContent;
        }
    }
    if ((0, assertions_1.isHotspotPinComponent)(pinComponent)) {
        const title = fn({
            tipTapContent: pinComponent.settings.title,
            componentId: pinComponent.id,
            field: 'component.settings.title',
            fragmentKey: 'title',
        });
        if (title) {
            pinComponent.settings.title = title;
        }
        else {
            delete pinComponent.settings.title;
        }
        const body = fn({
            tipTapContent: pinComponent.settings.body,
            componentId: pinComponent.id,
            field: 'component.settings.body',
            fragmentKey: 'body',
        });
        if (body) {
            pinComponent.settings.body = body;
        }
        else {
            delete pinComponent.settings.body;
        }
    }
}
exports.processPinComponentTipTapFields = processPinComponentTipTapFields;
//# sourceMappingURL=tip-tap.processor.js.map